export const analyticsConstants = {
  ofiLanding: 'ofi-landing-page',
  ofiYourDetails: 'ofi-your-details',
  ofiAccountInfo: 'ofi-account-info',
  ofiSuccess: 'ofi-success',
  ofiError: 'ofi-error',
};
